import GalleryCard from './GalleryCard';

export default GalleryCard;
